import React from "react";
import "./CarouselText.css";

const CarouselText = () => {
  const items = [
    "Web Development",
    "Web Design",
    "Product Design",
    "Brand Design",
    "Graphics Design",
    "UI/UX Design",
  ];

  return (
    <div className="carousel-outer">
      <div className="carousel-white">
        <div className="carousel-track">
          {items.concat(items).map((text, index) => (
             <React.Fragment key={index}>
             <div className="carousel-item">{text}</div>
             <img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091837/Star_1_vvtjst.png" alt="star" className="carousel-star" />
             </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CarouselText;
